/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-27 09:49:43
 */
import React, { Component } from 'react';
import { PubSub } from '@platform/api';
import { HotKeys } from 'react-hotkeys';
import { keyMap } from './config/tableKeyboardMap';
import { createByModuleType } from './createKeyMap';
import { handleArrowKeyDown, keyDownOfShiftUp } from './handleKeyDown';
import { stopEditTableHotKeyChange } from './config/stopHotKeyChange';
import { findNextFocusItemInTable } from './util/findNextFocusItemInTable';

function EditTableWithKeyboardChange(WrappedComponent) {
    return class WithKeyboardChange extends Component {
        constructor(props) {
            super(props);
            this.hotKeyWithEnter = this.hotKeyWithEnter.bind(this);
        }

        componentDidUpdate() {
            let { autoFocusDeferred } = this.props.getHotKeyConfig ? this.props.getHotKeyConfig() : {};
            if (stopEditTableHotKeyChange(this.props, autoFocusDeferred)) { return; }

            createByModuleType['editTable'](this.props);
        }

        componentDidMount() {
            this.autoFocusToken = PubSub.subscribe('autoFocus-IoC', () => {
                if (stopEditTableHotKeyChange(this.props, false)) { return; }
                createByModuleType['editTable'](this.props, true);
            });
        }

        componentWillUnmount() {
            this.autoFocusToken && PubSub.unsubscribe(this.autoFocusToken);
        }

        hotKeyWithEnter({ e, ViewModel, moduleId, target }) {
            //阻止冒泡会影响Page/index 下的keydown 事件
            //e.stopPropagation();
            let eventTarget = target || e.target;
            let { orderOfHotKey } = this.props.getHotKeyConfig ? this.props.getHotKeyConfig() : {};
            if (!orderOfHotKey) {
                console.warn('not find orderOfHotKey in getHotKeyConfig');
                return;
            }

            let timer = setTimeout(() => {
                findNextFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
                clearTimeout(timer);
            });
        }

        hotKeyWithArrow = ({ e, ViewModel, moduleId, itemType, target }) => {
            let eventTarget = target || e.target;
            let { orderOfHotKey } = this.props.getHotKeyConfig ? this.props.getHotKeyConfig() : {};
            if (!orderOfHotKey) {
                console.warn('not find orderOfHotKey in getHotKeyConfig');
                return;
            }

            handleArrowKeyDown({
                eventTarget,
                ViewModel,
                moduleId,
                orderOfHotKey,
                itemType,
                keyCode: e.keyCode,
            });
        };

        render() {
            let { flex } = this.props;
            return (
                <HotKeys
                    keyMap={keyMap}
                    handlers={{
                        shiftUp: keyDownOfShiftUp.bind(this, this.props.tableId || this.props.name),
                        shiftDown: keyDownOfShiftUp.bind(this, this.props.tableId || this.props.name),
                    }}
                    className={flex && 'flex-container'}
                >
                    <WrappedComponent
                        // tableStatusChanged={WithKeyboardChange.tableStatusChanged}
                        hotKeyWithEnter={this.hotKeyWithEnter}
                        hotKeyWithArrow={this.hotKeyWithArrow}
                        {...this.props}
                    />
                </HotKeys>
            );
        }
    };
}

export default EditTableWithKeyboardChange;
